import { makeStyles } from '@material-ui/core'
import { QuestionCircleOutlined } from '@ant-design/icons'
import React from 'react'
import moment from 'moment'
import JobLogs from './logs_table'
import { FileLink } from '../../components'
import { Card, Popover } from 'antd'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        boxSizing: 'border-box',
        marginLeft: theme.spacing(3),
        paddingTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto'
    },
    toolInformation: {
        background: '#FFFFFF',
        width: '100%',
        padding: theme.spacing(2)
    },
    jobDetails: {
        height: '100%',
        marginTop: theme.spacing(2),
        width: '100%',
        paddingTop: theme.spacing(2),
        minHeight: '50%'
    },
    informationTitle: {
        color: '##000000',
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '21px',
        position: 'relative'
    },
    informationContent: {

    },
    btn: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    testRunBtn: {
        outline: 'none',
        marginBottom: 2,
        border: 0,
        background: '#009D23',
        color: '#FFF',
        padding: theme.spacing(0.5, 2)
    },
    small: {
        fontSize: 12,
        fontWeight: 'bold'
    },
    details: {
        display: 'table',
        borderSpacing: '0 1em'
    },
    descriptionItem: {
        display: 'table-row',
    },
    itemHeader: {
        maxWidth: 180,
        width: 150,
        fontSize: 14,
        fontWeight: '600',
        lineHeight: '21px',
        display: 'table-cell',
        height: 20
    },
    itemText: {
        textAlign: 'start',
        display: 'table-cell',
        fontSize: 14
    },
    file_link: {
        color: '#000000',
        textDecoration: 'underline',
    },
    logTitle: {
        color: '##000000',
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    logs: {
        paddingTop: theme.spacing(1),
    }
}))

/**
 * Detailed information about a tool
 */
const ToolDetails = ({ tool, loading = false, runTest }) => {
    const classes = useStyles()

    /**
     * Format a given date string to DD-MM-YYYY
     * @param {string} date date string to format
     * @returns formatted date string
     */
    const formatDate = date => moment(date).format('DD-MM-YYYY')
    const formatDateTime = date => moment(date).format('DD-MM-YYYY H:mm')


    return tool ? (
        <div className={classes.root}>
            <Card className={classes.top} title="Tool Information" loading={loading}>
                <div className={classes.informationContent}>
                    <div className={classes.details}>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Tool ID</p>
                            <p className={classes.itemText}>{tool.id}</p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Name</p>
                            <p className={classes.itemText}>{tool.name}</p>
                        </div>
                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Spider Name</p>
                            <p className={classes.itemText}>{tool.spider_name}</p>
                        </div>
                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Category</p>
                            <p className={classes.itemText}>{tool.category}</p>
                        </div>
                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Tool Type</p>
                            <p className={classes.itemText}>{tool.type}</p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Type</p>
                            <p className={classes.itemText}>{tool.type}</p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Description</p>
                            <p className={classes.itemText}>
                                <pre>{tool.description}</pre>
                            </p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Sample input</p>
                            <p className={classes.itemText}>
                                <FileLink file_url={tool.sample_input_file} />
                            </p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Sample output</p>
                            <p className={classes.itemText}>
                                <FileLink file_url={tool.sample_out_file} />
                            </p>
                        </div>

                        <div className={classes.descriptionItem}>
                            <p className={classes.itemHeader}>Created at</p>
                            <p className={classes.itemText}>{`${formatDateTime(tool.created_at)} by`} <strong>{tool.created_by_name}</strong></p>
                        </div>

                    </div>
                </div>
            </Card>

            <Card className={classes.jobDetails} title="Job Details">
                <div className={classes.logs}>
                    <JobLogs tool_id={tool.id} />
                </div>
            </Card>
        </div>
    ) : null
}

export default ToolDetails
